import * as React from 'react';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$3 = ".styles_ticker__-0UvZ {\n  display: flex;\n  background-color: #0c0e15;\n  width: 100%;\n  overflow: hidden;\n  flex: 0 0 100%;\n\n  --gap: 1rem;\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  user-select: none;\n  gap: var(--gap);\n}\n\n.styles_ticker-list__1JKu- {\n  display: flex;\n  flex: 0 0 100%;\n  width: 100%;\n\n  flex-shrink: 0;\n  display: flex;\n  /* justify-content: space-around; */\n  min-width: 100%;\n}\n\n@keyframes styles_scroll__FP1n0 {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(calc(-100% - var(--gap)));\n  }\n}\n\n.styles_ticker__-0UvZ:hover .styles_ticker-list__1JKu- {\n  animation-play-state: paused;\n}\n\n@keyframes styles_ticker__-0UvZ {\n  0% {\n    transform: translateX(0%);\n  }\n\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.styles_tickerItem__Vj57z {\n  border-left: 1px solid transparent;\n  display: table-cell;\n  position: relative;\n  vertical-align: top;\n  color: #fff;\n  width: 100%;\n}\n\n.styles_tickerItem__Vj57z:hover {\n  background-color: #000;\n}\n\n.styles_tickerItem__Vj57z:after {\n  background: #2a2e39;\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  bottom: 10px;\n  left: -1px;\n  width: 1px;\n}\n";
var styles = {
  "ticker": "styles_ticker__-0UvZ",
  "ticker-list": "styles_ticker-list__1JKu-",
  "tickerItem": "styles_tickerItem__Vj57z",
  "scroll": "styles_scroll__FP1n0"
};
styleInject(css_248z$3);
var css_248z$2 = ".styles_tickerItemFinancial__m6Lt7 {\n  padding: 10px 15px;\n  height: 50px;\n  width: 180px;\n}\n\n.styles_tickerTopLevel__vRrjN {\n  display: flex;\n  text-transform: uppercase;\n  font-size: 12px;\n  height: 20px;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n}\n\n.styles_tickerStats__7TXcs {\n  display: flex;\n}\n\n.styles_tickerInfo__tzkOM {\n  display: flex;\n  align-items: baseline;\n  margin-left: 0.2rem;\n}\n\n.styles_tickerChangePercentage__GMiXr {\n  font-size: 22px;\n  line-height: 26px;\n}\n\n.styles_tickerCurrentPrice__CnVpc {\n  font-size: 12px;\n  margin: 0 0 0 8px;\n}\n\n.styles_tickerChangeNegative__4JfPL {\n  color: #ef5350;\n}\n\n.styles_tickerChangePositive__9AJcP {\n  color: #26a69a;\n}\n";
var stylesFinancial = {
  "tickerItemFinancial": "styles_tickerItemFinancial__m6Lt7",
  "tickerTopLevel": "styles_tickerTopLevel__vRrjN",
  "tickerStats": "styles_tickerStats__7TXcs",
  "tickerInfo": "styles_tickerInfo__tzkOM",
  "tickerChangePercentage": "styles_tickerChangePercentage__GMiXr",
  "tickerCurrentPrice": "styles_tickerCurrentPrice__CnVpc",
  "tickerChangeNegative": "styles_tickerChangeNegative__4JfPL",
  "tickerChangePositive": "styles_tickerChangePositive__9AJcP"
};
styleInject(css_248z$2);
var chevronUp = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%2326a69a%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20class%3D%22feather%20feather-chevron-up%22%3E%3Cpolyline%20points%3D%2218%2015%2012%209%206%2015%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E";
var chevronDown = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23ef5350%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20class%3D%22feather%20feather-chevron-down%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E";
/**
 * @component FinancialTicker
 */

var FinancialTicker = function FinancialTicker(props) {
  var statusClassName = props.change ? stylesFinancial.tickerChangePositive : stylesFinancial.tickerChangeNegative;
  return React.createElement("div", {
    "data-id": props.id,
    className: [styles.tickerItem, stylesFinancial.tickerItemFinancial].join(' ')
  }, React.createElement("div", {
    className: stylesFinancial.tickerTopLevel
  }, React.createElement("div", {
    className: stylesFinancial.tickerSymbol
  }, props.symbol), React.createElement("div", {
    className: stylesFinancial.lastPrice
  }, props.lastPrice)), React.createElement("div", {
    className: stylesFinancial.tickerStats
  }, React.createElement("img", {
    className: stylesFinancial.tickerMovement,
    src: props.change ? chevronUp : chevronDown,
    alt: props.change ? 'up' : 'down'
  }), React.createElement("div", {
    className: [statusClassName, stylesFinancial.tickerInfo].join(' ')
  }, React.createElement("div", {
    className: stylesFinancial.tickerChangePercentage
  }, props.percentage), React.createElement("div", {
    className: stylesFinancial.tickerCurrentPrice
  }, props.currentPrice))));
};

var css_248z$1 = ".styles_newsticker__py7eW {\n  min-width: 40%;\n  padding: 0.5rem;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  text-decoration: none;\n}\n\n.styles_newsWrapper__KvsKt {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n}\n\n.styles_title__n7qOv {\n  text-overflow: ellipsis;\n  word-wrap: none;\n  white-space: nowrap;\n  max-width: auto;\n  overflow: hidden;\n}\n\n.styles_title__n7qOv:hover {\n  text-decoration: underline;\n}\n\n.styles_meta__I1GUO {\n  font-size: 10px;\n}\n\n.styles_icon__HTIz4 {\n  width: 25px;\n}\n\n.styles_icon__HTIz4 img {\n  width: 100%;\n}\n";
var newsStyles = {
  "newsticker": "styles_newsticker__py7eW",
  "newsWrapper": "styles_newsWrapper__KvsKt",
  "title": "styles_title__n7qOv",
  "meta": "styles_meta__I1GUO",
  "icon": "styles_icon__HTIz4"
};
styleInject(css_248z$1);

var NewsTicker = function NewsTicker(props) {
  return React.createElement("a", {
    className: [newsStyles.newsticker, styles.tickerItem].join(' '),
    href: props.url,
    target: "_blank"
  }, React.createElement("div", {
    className: newsStyles.icon
  }, React.createElement("img", {
    src: props.icon,
    alt: props.iconAlt
  })), React.createElement("div", {
    className: newsStyles.newsWrapper
  }, React.createElement("div", {
    className: newsStyles.title
  }, props.title), React.createElement("small", {
    className: newsStyles.meta
  }, props.meta)));
};

var TickerList = function TickerList(props) {
  var animation = props.slideSpeed ? "scroll ".concat(props.slideSpeed, "s linear infinite") : 'scroll 15s linear infinite';
  return React.createElement("div", {
    className: styles.ticker
  }, React.createElement("div", {
    style: {
      animation: animation,
      display: "flex"
    }
  }, React.createElement("div", {
    className: styles['ticker-list']
  }, props.children), !props.isNewsTicker ? React.createElement("div", {
    className: styles['ticker-list'],
    "aria-hidden": true
  }, props.children) : ''));
};

var css_248z = "@keyframes scroll {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(calc(-100% - var(--gap)));\n  }\n}\n";
styleInject(css_248z);
export { FinancialTicker, NewsTicker, TickerList as default };